import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAlertsStore = defineStore('alerts', () => {
  // States
  const messages = ref([]);
  // Actions
  function showMessages(_messages) {
    messages.value = _messages;
  }
  function dismiss() {
    messages.value = [];
  }

  return {
    messages,
    dismiss,
    showMessages,
  };
});
